import { optionColor, INDUSTRY_OPTIONS } from '../lib/format.js'
import { DataTable, Chip, Avatar, Page, PageHeader, Eyebrow, Button } from '../ds/index.js'

export default function CompaniesView({ companies = [], usersById = {}, contactCounts = {}, engagementCounts = {}, onOpen, onCreate }) {
  const columns = [
    {
      key: 'name',
      header: 'Name',
      priority: 1,
      render: (c) => c.name || '—',
    },
    {
      key: 'domain',
      header: 'Domain',
      priority: 2,
      render: (c) => c.domain || '',
    },
    {
      key: 'industry',
      header: 'Industry',
      priority: 3,
      render: (c) =>
        c.industry
          ? (
            <Chip color={optionColor(INDUSTRY_OPTIONS, c.industry)}>
              {(INDUSTRY_OPTIONS.find((o) => o.value === c.industry) || {}).label || c.industry}
            </Chip>
          )
          : null,
    },
    {
      key: 'contacts',
      header: 'Contacts',
      priority: 3,
      render: (c) => <span className="font-mono">{`${contactCounts[c.id] || 0} ppl`}</span>,
    },
    {
      key: 'engagements',
      header: 'Engagements',
      priority: 3,
      render: (c) => <span className="font-mono">{`${engagementCounts[c.id] || 0} engagements`}</span>,
    },
    {
      key: 'owner',
      header: 'Owner',
      priority: 3,
      render: (c) => {
        const owner = usersById[c.ownerUid]
        return owner ? <Avatar user={owner} size={24} /> : null
      },
    },
  ]

  return (
    <Page wide>
      <PageHeader
        title="Companies"
        chip={<Eyebrow>Relationships</Eyebrow>}
        actions={<Button onClick={onCreate}>Add company</Button>}
      />
      <DataTable
        columns={columns}
        rows={companies}
        rowKey={(c) => c.id}
        onRowClick={(c) => onOpen(c.id)}
        empty="No companies yet."
      />
    </Page>
  )
}
